import React from "react";  
import { Link } from "react-router-dom";

function Topbar() {
  return (
    <>
{/* <header className="top-header">
  <nav className="navbar navbar-expand align-items-center gap-4"> 
    <div className="search-bar flex-grow-1">
     
    </div>
    <ul className="navbar-nav gap-1 nav-right-links align-items-center">
      
      <li className="nav-item dropdown">
        <a className="nav-link dropdown-toggle dropdown-toggle-nocaret position-relative" data-bs-auto-close="outside" data-bs-toggle="dropdown" href="javascript:;"><i className="material-icons-outlined">notifications</i>
       
        </a>
        <div className="dropdown-menu dropdown-notify dropdown-menu-end shadow">
          <div className="px-3 py-1 d-flex align-items-center justify-content-between border-bottom">
            <h5 className="notiy-title mb-0">Notifications</h5>
            <div className="dropdown">
              <button className="btn btn-secondary dropdown-toggle dropdown-toggle-nocaret option" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <span className="material-icons-outlined">
                  more_vert
                </span>
              </button>
              <div className="dropdown-menu dropdown-option dropdown-menu-end shadow">
                <div><a className="dropdown-item d-flex align-items-center gap-2 py-2" href="javascript:;"><i className="material-icons-outlined fs-6">inventory_2</i>Archive All</a></div>
                <div><a className="dropdown-item d-flex align-items-center gap-2 py-2" href="javascript:;"><i className="material-icons-outlined fs-6">done_all</i>Mark all as read</a></div>
                <div><a className="dropdown-item d-flex align-items-center gap-2 py-2" href="javascript:;"><i className="material-icons-outlined fs-6">mic_off</i>Disable Notifications</a></div>
                <div><a className="dropdown-item d-flex align-items-center gap-2 py-2" href="javascript:;"><i className="material-icons-outlined fs-6">grade</i>What's new ?</a></div>
                <div>
                  <hr className="dropdown-divider"/>
                </div>
                <div><a className="dropdown-item d-flex align-items-center gap-2 py-2" href="javascript:;"><i className="material-icons-outlined fs-6">leaderboard</i>Reports</a></div>
              </div>
            </div>
          </div>
          <div className="notify-list">
             
         
         
          </div>
        </div>
      </li>
     
    </ul>

  </nav>
</header> */}
    </>
  );
}

export default Topbar;
